<template>
  <div>
    <!--Control Component -->
    <b-input-group @click="openModal()" v-if="isModal">
      <b-form-input readonly :value="sectionString" class="me-2"></b-form-input>
      <div>
        <b-button v-b-modal.locationSubModal variant="outline-info">
          <b-icon icon="arrows-angle-expand"></b-icon>
        </b-button>
      </div>
    </b-input-group>

    <!--Modal Component -->
    <b-modal v-if="isModal" v-model="is_visible" no-close-on-backdrop :title="modalTitle" title-class="p-2"
      header-class="p-0" footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap"
      hide-footer size="lg">
      <portal-target name="locationSectionComp"></portal-target>
    </b-modal>

    <!--Section Component -->
    <portal to="locationSectionComp" :disabled="!isModal || !is_visible" v-show="!isModal || is_visible">
      <b-card :title="title" title-tag="h6">
        <LocationList v-if="listMode" ref="locationListRef" :customer_id="customer_id" title="Customer Addresses"
          @set-location="setSelectedLocation" @create-location="setCreateLocationMode" />

        <!-- {{ sectionOnly  }} -->
        <location-view v-else ref="locationViewRef" :id="location?.id" :required="required" :section-only="sectionOnly"
          :disabled="disabled" :hide-controls="true" :loading="loading" :customer_id="customer_id"
          @update-location-model="triggerUpdateLocation">
          <template #default>
            <b-button :disabled="disabled || !(customer_id > 0)" v-if="!hideControls" class="mr-2 mt-2" variant="info"
              @click="setSearchMode">{{ $translate('locations') }}</b-button>
          </template>
          <template #section>
            <b-col cols="12" class="mb-4">
              <label class="mb-2"><strong>{{
      $translate('section_name')
    }}</strong>
              </label>
              <b-form-select v-if="sections.length > 0" id="section-name" v-model="selected_section_id"
                :disabled="disabled" text-field="name" value-field="id" :options="sections">
                <template #first>
                  <b-form-select-option disabled :value="null" selected>
                    {{ $translate('enter_section_name') }}
                  </b-form-select-option>
                </template>
              </b-form-select>
              <b-form-input v-else id="section-name" v-model="section_name"
                placeholder="Default Section Name"></b-form-input>
            </b-col>
          </template>
        </location-view>

        <slot :hide-modal="hideModal" :set-location="setLocation" :set-search-mode="setSearchMode"></slot>

      </b-card>
    </portal>
  </div>
</template>

<script>
import EventBus from '@/exports/event-bus.js'

import { debounce } from 'lodash'
import LocationView from './LocationView'
import LocationList from './LocationList'

import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
  name: 'LocationSection',
  components: { LocationView, LocationList },
  mixins: [popupMixins, permissionsMixins],
  data() {
    return {
      mounting: false,
      filters: {},
      section_name: '',
      listMode: false,
      location_sections: [],
      location: null,
      is_visible: false,
      currentSectionId: 0,
    }
  },

  props: {
    sectionOnly: { type: Boolean },
    value: { type: Number, default: 0 },
    hideControls: { type: Boolean },
    title: { type: String },
    disabled: { type: Boolean },
    loading: { type: Boolean },
    modalTitle: { type: String },
    isModal: { type: Boolean },
    required: { type: Boolean },
    customer_id: { type: Number, default: 0 },
  },
  computed: {
    locations() {
      return this.$store.state.locations.locations;
    },
    sections() {
      return this.$store.getters['locations/sections']
    },

    sectionString() {
      const { proper_section_name: section_name, location } = this
      let { address1, address2 } = location || {}
      address1 = address1 || ''
      address2 = address2 || ''
      return address1 || address2
        ? `${address1 && address2
          ? address1 + ', ' + address2
          : address1
            ? address1
            : address2
        } (${section_name})`
        : this.$translate('asset_location_placeholder')
    },


    locationSectionData() {
      const { proper_section_name: section_name, location } = this
      return JSON.stringify({ section_name, location });
    },

    proper_section_name() {
      const { selected_section_id, section_name, sections } = this;
      if (sections.length > 0) {
        return sections.find(x => x.id == selected_section_id)?.name ?? "";
      } else {
        return section_name ?? "";
      }
    },

    selected_section_id: {
      get: function () { return this.value },
      set: function (val) {
        this.$emit("input", val)
      },
    },

    hasSlot() {
      return !!this.$slots.default;
    },


  },
  watch: {
    listMode: {
      immediate: true,
      handler: function (val) {
        this.$emit('searchMode', val)
      },
    },

    selected_section_id: {
      immediate: true,
      handler: debounce(function (to, from) {
        this.setSection(to, from)
      }, 500),
    },


    locationSectionData: {
      immediate: true, handler: function (val) {
        val && this.$emit("set-location-section", JSON.parse(val));
      }
    }
  },
  created() {
    EventBus.$on('set-location-search-mode', () => {
      this.setSearchMode()
    })
  },
  mounted() {
    this.listMode = false
  },
  methods: {
    openModal() {
      this.is_visible = true
    },
    hideModal() {
      this.is_visible = false
    },
    setLocation() {
      this.is_visible = false
      this.genericToast(
        this.$translate('location_section'),
        this.$translate('added'),
        'success',
        `${this.$translate('location_section')} ${this.$translate(
          'add_alert'
        )} `
      )
    },



    setSearchMode() {
      this.listMode = true
    },
    setCreateLocationMode() {
      this.selected_section_id = null
      this.location = {}
      console.log("breakpoint--3")
      this.listMode = false
    },

    setSelectedLocation(_location) {
      this.location = _location
      if(_location.sections && _location.sections.length > 0){
        this.selected_section_id = _location.sections[0].id
      }
      this.listMode = false;
    },

    async setSection(id) {
      const section = await this.$store.dispatch('locations/getSection', id)
      const { selected_section_id } = this;
      console.log("setSection:", { id, selected_section_id, section })
      if (id && selected_section_id == id) {
        this.setSelectedLocation(section.location);
      }
    },

    getSectionModel() {
      const { proper_section_name: section_name, location } = this
      return {
        section_name,
        location,
      }
    },

    triggerUpdateLocation(_location) {
      this.location = _location;
    },


  },
}
</script>
